import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const oneTimeSignatureAddresssesStarted = () => {
  return {
    type: actionTypes.GET_ONE_TIME_SIGNATURE_ADDRESSES_STARTED,
  };
};
export const oneTimeSignatureAddresssesSuccess = (oneTimeSignatureDetails) => {
  return {
    type: actionTypes.GET_ONE_TIME_SIGNATURE_ADDRESSES_SUCCESS,
    oneTimeSignatureDetails: oneTimeSignatureDetails,
  };
};
export const oneTimeSignatureAddresssesFailed = (errorMessage) => {
  return {
    type: actionTypes.GET_ONE_TIME_SIGNATURE_ADDRESSES_FAILED,
    errorMessage: errorMessage,
  };
};

export const getOneTimeSignatureAddresses = (patientId: string) => {
  return (dispatch) => {
    dispatch(oneTimeSignatureAddresssesStarted());
    axios
      .get(serverconfigs.oneTimeSignatureAddressesUrl+`/${patientId}`)
      .then((response) => {
        console.log(response.data);
        dispatch(oneTimeSignatureAddresssesSuccess(response.data.result));
      })
      .catch((error) => {
        // const result = {
        //   id: 2507761,
        //   addresses: [
        //     {
        //       addressLine1: "875 HUDO STREET",
        //       addressLine2: null,
        //       city: "City Name A",
        //       state: "CA",
        //       postalCode: "12345",
        //       source: "Address",
        //       addressLine3: null,
        //     },
        //     {
        //       addressLine1: "875 HUDO STREET",
        //       addressLine2: null,
        //       addressLine3: null,
        //       city: "UFESUEC",
        //       state: "KY",
        //       postalCode: "76596",
        //       source: "Patient",
        //     },
        //   ],
        //   documentIsSet: true,
        // };
        // dispatch(oneTimeSignatureAddresssesSuccess(result));
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(oneTimeSignatureAddresssesFailed(error.message));
      });
  };
};
